import FileDirectory from './FileDirectory';
import { useState, useEffect } from 'react'
import { connect } from 'react-redux'

const FunctionalitySelector = ({ plugins, ...props }) => {

  const orchestrator = plugins['weaver-orchestrator']
  const [functionalities, setFunctionalities] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const _functionalities = JSON.parse(await orchestrator.getFunctionalities())
      setFunctionalities(parseFunctionalities(_functionalities));
    };

    try {
      fetchData();
    } catch (error) {
      console.error(error.message || 'Error fetching functionalities');
    }
  }, []);

  const parseFunctionalities = (_functionalities) => {
    const root = {};

    _functionalities.forEach((item) => {
      const levels = item.name.split('.');
      let current = root;

      levels.forEach((level, index) => {
        if (!current[level]) {
          current[level] = { children: {} };
        }

        if (index === levels.length - 1) {
          if (!current[level].children[item.version]) {
            current[level].children[item.version] = {
              ...item,
              name: `v${item.version}`,
              children: {},
            };
          }
        }

        current = current[level].children;
      });
    });

    const convertToTree = (node) => {
      return Object.keys(node).map((key) => {
        const { children, ...rest } = node[key];
        return {
          name: key,
          ...rest,
          children: convertToTree(children),
        };
      });
    };

    return convertToTree(root);
  };


  return (
    <FileDirectory
      treeData={functionalities}
      {...props}
    />
  )
}

const mapStateToProps = ({ explore: { plugins }}) => ({ plugins })
export default connect(mapStateToProps)(FunctionalitySelector)
